import type { Table } from '@tanstack/react-table';
import { useCallback } from 'react';
import { ColumnGroup } from '../types';
import {
  createSortReactTableRowsForCurrentSorting,
  createSortRowsForCurrentSorting,
} from '../utils/sorting';

export function useSorting<TData, TValue>(
  table: Table<TData>,
  finalColumnGroups: ColumnGroup<TData, TValue>[],
  isClientSortingDisabled = false
) {
  const sortRowsForCurrentSorting = useCallback(
    createSortRowsForCurrentSorting<TData, TValue>(
      table,
      finalColumnGroups,
      isClientSortingDisabled
    ),
    [table, finalColumnGroups, isClientSortingDisabled]
  );

  const sortReactTableRowsForCurrentSorting = useCallback(
    createSortReactTableRowsForCurrentSorting<TData, TValue>(
      table,
      finalColumnGroups,
      isClientSortingDisabled
    ),
    [table, finalColumnGroups, isClientSortingDisabled]
  );

  return {
    sortRowsForCurrentSorting,
    sortReactTableRowsForCurrentSorting,
  } as const;
}
